import axiosNoLoading from "./axiosNoLoading";
import config from "../config/config";

const GATEWAY_URL = config.servers.gateway.url;

export interface MSAppConfigItem {
  appName: string;
  favIconUrl: string;
  extensions: string[];
}

let cache: MSAppConfigItem[] | null = null;

export async function initMSAppConfig(): Promise<void> {
  const resp = await axiosNoLoading.get<MSAppConfigItem[]>(
    `${GATEWAY_URL}/papi/public/wopi/apps/config`
  );
  cache = resp.data;
}

export function getAppNameByExtension(ext: string): string | null {
  if (!cache) return null;
  const lower = ext.toLowerCase();
  const item = cache.find((c) =>
    c.extensions.some((e) => e.toLowerCase() === lower)
  );
  return item?.appName ?? null;
}

export function getFavIconUrlByExtension(ext: string): string | null {
  if (!cache) return null;
  const lower = ext.toLowerCase();
  const item = cache.find((c) =>
    c.extensions.some((e) => e.toLowerCase() === lower)
  );
  return item?.favIconUrl ?? null;
}
